/* TEMP FIX: force navigation for mobile menu links */
(() => {
  const DEBUG = true;
  const log = (...a) => DEBUG && console.log("[menu-fix]", ...a);

  const findAnchor = (e) => {
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    const aInPath = path.find((n) => n && n.tagName === "A");
    return aInPath || e.target?.closest?.("a") || null;
  };

  window.addEventListener(
    "pointerdown",
    (e) => {
      // Only left click / primary touch
      if (e.button != null && e.button !== 0) return;

      const a = findAnchor(e);
      if (!a) return;

      // Optional: limit to your mobile menu text spans so we don't affect the whole site
      const isMenuText = e.target?.classList?.contains("mnavig_sublink_text");
      if (!isMenuText) return;

      const hrefAttr = a.getAttribute("href") || "";
      if (!hrefAttr || hrefAttr === "#" || hrefAttr.startsWith("javascript:")) return;

      // Respect open-in-new-tab behaviours
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== "_self") return;

      log("FORCING navigation", { hrefAttr, resolved: a.href });

      // Prevent theme/mobile-drawer handlers from cancelling navigation
      e.preventDefault();
      e.stopImmediatePropagation();

      window.location.assign(a.href);
    },
    true
  );

  log("Installed pointerdown mobile force-nav fix");
})();

/* Other code */

function tabClick(e){9===e.keyCode&&(document.body.classList.add("js-using-tab"),window.removeEventListener("keydown",tabClick))}
function wrap(e,t){e.parentNode.insertBefore(t,e),t.appendChild(e)}
window.addEventListener("keydown",tabClick);

document.querySelectorAll(".rte table").forEach((tbl) => {
  const tableWrapper = document.createElement("div");
  tableWrapper.style.cssText = "overflow:auto;-webkit-overflow-scrolling:touch";
  wrap(tbl, tableWrapper);
});

const scrollEndSupported="undefined"==typeof window||"onscrollend"in window;
scrollEndSupported||import("scrollyfills");
//# sourceMappingURL=global.js.map
